import { DashboardLayoutCustomer } from "../../components/dashboard-layout-customer";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";

import { Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { t } from "i18next";
import { useLocation, useNavigate } from "react-router-dom";

function SetTX() {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const SANH_ID = parseInt(queryParams.get("sanh")) || 1;

    const [list30, setList30] = useState();
    const [bet, setBet] = useState(null);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [second, setSecond] = useState(0);
    const [dulieunhap, setDulieunhap] = useState(null);
    const [current, setCurrent] = useState(null);
    const [chimMoiList, setChimMoiList] = useState([]);

    function formatDate(m) {
        const d = new Date(m);
        return d.getFullYear() + "/" + 
               ("0" + (d.getMonth() + 1)).slice(-2) + "/" + 
               ("0" + d.getDate()).slice(-2) + "  " + 
               ("0" + d.getHours()).slice(-2) + ":" + 
               ("0" + d.getMinutes()).slice(-2);
    }

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) config.headers["Authorization"] = `Bearer ${token}`;
            return config;
        },
        (error) => Promise.reject(error)
    );

    const getBetLabel = (stateStr) => {
        if (!stateStr) return "";
        const map = { "1": "CHẴN", "2": "LẺ", "3": "TÀI", "4": "XỈU" };
        return stateStr.split(" ").map(s => map[s] || s).join(", ");
    };

    const reloadHistorySilently = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/TX45s/list30bet?sanh=${SANH_ID}`).then((res) => {
            setList30(res.data.data);
        }).catch(() => setList30(null));

        axios.get(`${process.env.REACT_APP_API_URL}/tx45s/get?sanh=${SANH_ID}`).then((res) => {
            if (res.data && res.data.data) setBet(res.data.data);
        });
    };

    const fetchCurrentBets = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/TX45s/getcurrent?sanh=${SANH_ID}`).then((res) => {
            if (res.data && res.data.data) setCurrent(res.data.data);
        }).catch(() => setCurrent([]));
    };

    const fetchChimMoiList = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/auth/chimmoi?code=tx45ssanh${SANH_ID}`)
            .then(res => { if (res.data?.data) setChimMoiList(res.data.data); })
            .catch(() => setChimMoiList([]));
    };

    const fetchNewSessionAdmin = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/tx45s/get?sanh=${SANH_ID}`).then((res) => {
            if (res.data?.data) {
                setBet(res.data.data);
                setDulieunhap(new Date(res.data.data.createdAt));
            }
        });
        reloadHistorySilently();
        fetchCurrentBets(); 
        fetchChimMoiList(); 
    };

    useEffect(() => {
        setBet(null);
        setCurrent(null);
        fetchNewSessionAdmin();
    }, [SANH_ID]);

    useEffect(() => {
        if (!dulieunhap) return;
        const timer = setInterval(() => {
            const now = new Date();
            const diff = Math.floor((now.getTime() - dulieunhap.getTime()) / 1000);
            const remaining = 45 - diff; 
            if (remaining < 0) {
                setSecond(0);
                fetchNewSessionAdmin();
            } else {
                setSecond(remaining);
            }
        }, 500);
        return () => clearInterval(timer);
    }, [dulieunhap]);

    useEffect(() => {
        const poll = setInterval(() => fetchCurrentBets(), 1500);
        return () => clearInterval(poll);
    }, [SANH_ID]);

    function thongke(num) {
        if (current?.length > 0) {
            let totalMoney = 0;
            current.forEach((item) => {
                const states = item.state.split(" ").map(Number);
                if (states.includes(num)) {
                    totalMoney += item.money / states.length;
                }
            });
            return Number(totalMoney).toLocaleString("vi-VN");
        }
        return 0;
    }

    const currentSessionData = list30?.find(item => item.id_bet === bet?.id_bet);
    const displayResult = currentSessionData?.result || bet?.result;

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayoutCustomer>
                <Box component="main" sx={{ flexGrow: 1, py: 1 }}>
                    <Container maxWidth={false}>
                        {/* CHỌN SẢNH */}
                        <Box sx={{ display: 'flex', gap: 1, mb: 3, flexWrap: 'wrap' }}>
                            {[1, 2, 3, 4, 5, 6].map((sanhId) => (
                                <Button
                                    key={sanhId}
                                    variant={SANH_ID === sanhId ? "contained" : "outlined"}
                                    onClick={() => navigate(`?sanh=${sanhId}`)}
                                    sx={{ fontWeight: 'bold', minWidth: '100px' }}
                                >
                                    SẢNH {sanhId}
                                </Button>
                            ))}
                        </Box>

                        <div className="container_set" style={{ textAlign: 'center', fontSize: '20px', fontWeight: 'bold' }}>SẢNH {SANH_ID} - THEO DÕI TÀI XỈU 45S</div>

                        {/* PHIÊN VÀ THỜI GIAN */}
                        <div className="cycle_bet" style={{ textAlign: 'center', margin: '20px 0' }}>
                            {bet ? (
                                <span style={{ color: "black", fontSize: '18px' }}>{t('session')} <b>{bet.id_bet}</b></span>
                            ) : (
                                <span>{t('waiting')}</span>
                            )}
                            <div style={{ color: "red", fontSize: '30px', fontWeight: 'bold' }}>
                                00 : {second < 10 ? "0" : ""}{second >= 0 ? second : 0}
                            </div>
                        </div>

                        {/* THỐNG KÊ TIỀN CƯỢC HIỆN TẠI */}
                        <div className="current_bet" style={{ backgroundColor: '#f5f5f5', padding: '15px', borderRadius: '8px' }}>
                            <div className="current_bet_head" style={{ display: 'flex', justifyContent: 'space-around', fontWeight: 'bold', borderBottom: '1px solid #ccc', pb: 1 }}>
                                <div>CHẴN</div><div>LẺ</div><div>TÀI</div><div>XỈU</div>
                            </div>
                            <div className="current_bet_body" style={{ display: 'flex', justifyContent: 'space-around', pt: 1, fontSize: '18px' }}>
                                <div style={{ color: '#1976d2', fontWeight: 'bold' }}>{thongke(1)}</div>
                                <div style={{ color: '#d32f2f', fontWeight: 'bold' }}>{thongke(2)}</div>
                                <div style={{ color: '#d32f2f', fontWeight: 'bold' }}>{thongke(3)}</div>
                                <div style={{ color: '#1976d2', fontWeight: 'bold' }}>{thongke(4)}</div>
                            </div>
                        </div>

                        {/* KẾT QUẢ HIỆN TẠI */}
                        <Box sx={{ mt: 3, p: 2, bgcolor: 'white', borderRadius: 1, boxShadow: 1, textAlign: 'center' }}>
                            <Typography variant="h6">
                                Kết quả phiên đang mở: {" "}
                                <span style={{ fontWeight: "900", color: "red", fontSize: '24px' }}>
                                    {displayResult && displayResult.trim() !== "" ? displayResult : "Đang chờ..."}
                                </span>
                            </Typography>
                        </Box>

                        <Box sx={{ mt: 3 }}>
                            <Typography variant="h6" sx={{ mb: 1 }}>DANH SÁCH KHÁCH ĐANG CƯỢC</Typography>
                            <Table size="small" sx={{ bgcolor: 'white' }}>
                                <TableHead><TableRow sx={{ bgcolor: '#f0f0f0' }}>
                                    <TableCell>ID</TableCell><TableCell>Tài Khoản</TableCell><TableCell>Cửa Đặt</TableCell><TableCell>Tiền Cược</TableCell><TableCell>Thời Gian</TableCell>
                                </TableRow></TableHead>
                                <TableBody>
                                    {current?.length > 0 ? current.map((item, idx) => (
                                        <TableRow key={idx}>
                                            <TableCell>{item?.user?.iduser}</TableCell>
                                            <TableCell>{item?.user?.username}</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', color: '#e53935' }}>{getBetLabel(item.state)}</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', color: '#2e7d32' }}>{Number(item.money).toLocaleString("vi-VN")}</TableCell>
                                            <TableCell>{formatDate(item.createdAt)}</TableCell>
                                        </TableRow>
                                    )) : <TableRow><TableCell colSpan={5} align="center">Chưa có khách cược phiên này</TableCell></TableRow>}
                                </TableBody>
                            </Table>
                        </Box>

                      

                    </Container>
                </Box>
            </DashboardLayoutCustomer>
        </ThemeProvider>
    );
}
export default SetTX;